import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ClocheMark, EASE, EASE_IN_OUT } from "./primitives";

/**
 * Kort openingsgordijn: het cloche-logo zendt uit, "Service!" verschijnt en het doek
 * schuift omhoog. Eén keer per sessie; `onDone` laat de hero starten.
 */
export default function IntroCurtain({ show, onDone }) {
   const [open, setOpen] = useState(show);

   useEffect(() => {
      if (!show) return;
      const t = setTimeout(() => setOpen(false), 1500);
      return () => clearTimeout(t);
   }, [show]);

   return (
      <AnimatePresence onExitComplete={onDone}>
         {open && (
            <motion.div
               key="curtain"
               className="fixed inset-0 z-[500] flex items-center justify-center bg-lp-ink text-lp-paper"
               initial={{ clipPath: "inset(0% 0% 0% 0%)" }}
               exit={{ clipPath: "inset(0% 0% 100% 0%)" }}
               transition={{ duration: 0.95, ease: EASE_IN_OUT }}
            >
               <motion.div
                  className="flex flex-col items-center"
                  exit={{ y: -60, opacity: 0 }}
                  transition={{ duration: 0.6, ease: EASE_IN_OUT }}
               >
                  <ClocheMark animate className="h-[72px] w-[80px]" color="#F3EEE5" />
                  <span className="mt-6 block overflow-hidden">
                     <motion.span
                        className="block font-editorial text-6xl italic sm:text-7xl"
                        initial={{ y: "110%" }}
                        animate={{ y: 0 }}
                        transition={{ duration: 0.9, ease: EASE, delay: 0.45 }}
                     >
                        Service!
                     </motion.span>
                  </span>
               </motion.div>
               <motion.span
                  className="absolute bottom-8 left-1/2 -translate-x-1/2 font-ticket text-[11px] uppercase tracking-[0.2em] text-lp-paper/50"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3 }}
               >
                  Resto-Online
               </motion.span>
            </motion.div>
         )}
      </AnimatePresence>
   );
}
